import React from 'react';
import { Link } from 'react-router-dom';

// Types
import { GoalItem } from 'Shared/constants/types';

// Utils
import PageUrlsUtils from 'Shared/utils/PageUrls.utils';

// Hooks
import { useGoal } from 'Shared/utils/hooks/use-goal';

// Components
import WpIcon from 'Wpds/components/icon/WpIcon';

// Styles
import './GoalWorkspace.scss';

type Props = {
  goal: GoalItem;
  linkTo?: boolean;
};

const GoalWorkspace = ({ goal, linkTo = true }: Props) => {
  const { workspace, workspaceLabel: displayLabel } = useGoal({ slug: goal.slug });

  if (!workspace) return null;

  const baseClassName = 'GoalWorkspace';
  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__icon`}>
        <WpIcon name="user-friends" size="sm" />
      </div>
      {linkTo ? (
        <Link
          className={`${baseClassName}__link`}
          to={PageUrlsUtils.makeWorkspaceUrl(goal.workspaceSlug)}
          onClick={e => e.stopPropagation()}
        >
          {displayLabel}
          <div className={`${baseClassName}__external-link`}>
            <WpIcon name="external-link" size="sm" />
          </div>
        </Link>
      ) : (
        displayLabel
      )}
    </div>
  );
};

export default GoalWorkspace;
